import { render, staticRenderFns } from "./StudentChangeCoachDialog.vue?vue&type=template&id=d61cf0ea&scoped=true"
import script from "./StudentChangeCoachDialog.vue?vue&type=script&lang=js"
export * from "./StudentChangeCoachDialog.vue?vue&type=script&lang=js"
import style0 from "./StudentChangeCoachDialog.vue?vue&type=style&index=0&id=d61cf0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61cf0ea",
  null
  
)

export default component.exports